import { createContext, useState } from "react";
export const AlertNotificationContext = createContext();

export function AlertNotificationProvider(props) {
  const [alertNotification, setAlertNotification] = useState({
    message: "",
    severity: "",
  });

  return (
    <AlertNotificationContext.Provider
      value={{ alertNotification, setAlertNotification }}
    >
      {props.children}
    </AlertNotificationContext.Provider>
  );
}
